import {
   CurrentDoctorSimpleQuery,
   DoctorSimple,
   DoctorSimpleFromCurrentHealthcareProviderQuery,
} from '@dreryk/egabinet-personnel-frontend-api';
import { PatientGroup, PatientGroupQuery } from '@dreryk/egabinet-patient-frontend-api';

import { useCqrsFind, useCqrsSearch } from '@dreryk/command-query-react-common';
import { commonTranslationKeys } from '@dreryk/react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';

type AppointmentsPanelLoaderRenderProps = {
   doctors: DoctorSimple[];
   currentDoctor: DoctorSimple | null;
   patientGroups: PatientGroup[];
};

type AppointmentsPanelLoaderProps = {
   readonly children: (renderProps: AppointmentsPanelLoaderRenderProps) => JSX.Element;
};

export const AppointmentsPanelLoader = (props: AppointmentsPanelLoaderProps): JSX.Element => {
   const { data: doctors, loading: doctorsLoading, error: doctorsError } = useCqrsSearch<DoctorSimple>(
      () => new DoctorSimpleFromCurrentHealthcareProviderQuery()
   );

   const { data: currentDoctor, loading: currentDoctorLoading, error: currentDoctorError } = useCqrsFind<DoctorSimple>(
      () => new CurrentDoctorSimpleQuery()
   );

   const { data: patientGroups, loading: patientGroupLoading, error: patientGroupError } = useCqrsSearch<PatientGroup>(
      () => new PatientGroupQuery()
   );

   if (doctorsLoading || currentDoctorLoading || patientGroupLoading) {
      return <LoaderSpinner />;
   }

   if (doctorsError || currentDoctorError || patientGroupError) {
      return (
         <Message
            testId={'fetchError'}
            type={MessageType.NEGATIVE}
            label={commonTranslationKeys.unexpectedErrorHasOccurred}
            displayIndicator
         />
      );
   }

   return props.children({
      doctors: doctors,
      currentDoctor: currentDoctor,
      patientGroups: patientGroups,
   });
};
